import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Space,
  Table,
  InputNumber,
  Card,
  Select,
  Row,
  Col,
  Switch,
  Tag,
} from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";

import { useDispatch } from "react-redux";

import { LocalImage } from "../../components/ImageUtil";
import modulesApi from "../../api/module/modulesApi";
import UploadFileProp from "../../components/UploadFileProp";

const SliderCenterHome = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);

  const [titleModal, setTitleModal] = useState("");
  const [isEditModal, setEditModal] = useState(false);
  const [valueFormData, setValueFormData] = useState({
    title: null,
    link: null,
    order: null,
    active: null,
    itemIndex: null,
  });

  const [sliderItems, setSliderItems] = useState([]);

  const [bannerPc, setBannerPc] = useState(null);
  const [bannerMb, setBannerMb] = useState(null);

  useEffect(() => {
    getHomeFeaturedBanner();
  }, []);

  useEffect(() => {
    form.setFieldsValue(valueFormData);
  }, [form, valueFormData, isEditModal]);

  const getHomeFeaturedBanner = () => {
    setLoading(true);
    modulesApi
      .getHomeFeaturedBanner()
      .then((res) => {
        if (res?.values !== null) {
          setLoading(false);
          const data = res?.values;
          setSliderItems(data);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "STT",
      render: (id, record, order) => {
        ++order;
        return order;
      },
      className: "text-center",
      width: "5%",
    },
    {
      title: "Ảnh PC",
      dataIndex: "pcImage",
      render: (image) => (
        <>
          <LocalImage
            src={image}
            width={100}
            style={{ objectFit: "contain" }}
            height={100}
          />
        </>
      ),
      width: 250,
    },
    {
      title: "Ảnh Mobile",
      dataIndex: "mbImage",
      render: (image) => (
        <>
          <LocalImage
            src={image}
            width={100}
            style={{ objectFit: "contain" }}
            height={100}
          />
        </>
      ),
      width: 250,
    },
    {
      title: "Tên banner",
      dataIndex: "title",
      render: (title) => <h3>{title}</h3>,
    },
    {
      title: "Liên kết",
      dataIndex: "link",
      render: (text) => (
        <a target={"_blank"} href={text}>
          {text}
        </a>
      ),
    },
    {
      title: "Thứ tự hiển thị",
      dataIndex: "order",
      className: "text-center",
      width: "5%",
    },
    {
      title: "Trạng thái",
      dataIndex: "active",
      render: (display) => (
        <>
          {display === true && (
            <Tag color="green" key={display}>
              Hoạt động
            </Tag>
          )}
          {display === false && (
            <Tag color="red" key={display}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
      className: "text-center",
      width: 50,
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record, index) => (
        <Space size="middle">
          <Button
            onClick={() => showEditModal(record, index)}
            value="large"
            icon={<EditOutlined />}
          >
            Sửa
          </Button>
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deleteSlider(index)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
      fixed: "right",
    },
  ];

  const confirm = Modal.confirm;

  const showEditModal = (record, index) => {
    // console.log(record);
    setTitleModal("Sửa banner");
    setBannerPc(record.pcImage);
    setBannerMb(record.mbImage);
    setValueFormData({
      title: record.title,
      link: record.link,
      order: record.order,
      active: record.active,
      itemIndex: index,
    });
    setEditModal(true);
    setIsModalEditVisible(true);
  };

  const showCreateModal = () => {
    setTitleModal("Thêm banner");
    setBannerPc(null);
    setBannerMb(null);
    setValueFormData({
      title: null,
      link: null,
      order: null,
      active: null,
      itemIndex: null,
    });
    setEditModal(false);
    setIsModalEditVisible(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = useCallback(
    (values) => {
      if (isEditModal) {
       updateSlider(values);
      } else {
        const check = bannerPc === null || bannerMb === null;
        if (!check) {
          createSlider(values);
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Vui lòng tải ảnh lên!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
      }
    },
    [isEditModal, bannerMb, bannerPc]
  );

  const createSlider = (data) => {
    const item = {
      title: data.title,
      pcImage: bannerPc,
      mbImage: bannerMb,
      link: data.link,
      order: data.order,
      active: data.active,
    };
    const mapData = sliderItems.map((item) => {
      return {
        title: item.title,
        pcImage: item.pcImage,
        mbImage: item.mbImage,
        link: item.link,
        order: item.order,
        active: item.active,
      };
    });
    console.log(mapData);

    const payload = {
      "home-featured-banner": [...mapData, item],
    };

    actionApi(payload);
  };

  const updateSlider = (data) => {
    setLoading(true);
    const item = {
      title: data.title,
      pcImage: bannerPc,
      mbImage: bannerMb,
      link: data.link,
      order: data.order,
      active: data.active,
    };
    console.log(item);

    const mapData = sliderItems.map((item) => {
      return {
        title: item.title,
        pcImage: item.pcImage,
        mbImage: item.mbImage,
        link: item.link,
        order: item.order,
        active: item.active,
      };
    });

    const newState = mapData.map((obj, order) => {
      if (order === data.itemIndex) {
        return { ...obj, ...item };
      }
      return obj;
    });

    const payload = {
      "home-featured-banner": newState,
    };

    actionApi(payload);
  };

  const deleteSlider = (order) => {
    console.log(order);
    confirm({
      title: "Bạn có muốn xóa slider này không?",
      onOk() {
        const items = sliderItems;
        items.splice(order, 1);

        const mapData = items.map((item) => {
          return {
            title: item.title,
            pcImage: item.pcImage,
            mbImage: item.mbImage,
            link: item.link,
            order: item.order,
            active: item.active,
          };
        });

        const payload = {
          "home-featured-banner": mapData,
        };
        actionApi(payload);
      },
      onCancel() {},
    });
  };

  const actionApi = (payload) => {
    setLoading(true);
    modulesApi
      .createModules(payload)
      .then((res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Thao tác thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          getHomeFeaturedBanner();
          setIsModalEditVisible(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const closePopup = useCallback(() => {
    setValueFormData({
      title: null,
      link: null,
      order: null,
      active: null,
      itemIndex: null,
    });
    form.resetFields();
    setIsModalEditVisible(false);
    setBannerPc(null);
    setBannerMb(null);
  }, [form]);

  const onUploadPc = (url) => {
    setBannerPc(url);
  };

  const onUploadMb = (url) => {
    setBannerMb(url);
  };

  return (
    <>
      <div className="tabled">
        <Space size={10}>
          <Button
            type="dashed"
            onClick={() => showCreateModal()}
            size="small"
            disabled={sliderItems.length >= 3}
          >
            <EditOutlined /> &nbsp; Thêm banner
          </Button>
        </Space>
        <br />
        <br />
        <Card bordered={true} className="criclebox tablespace mt-10 mb-24">
          <div className="table-responsive">
            <Table
              rowKey={(record) => record.order + Math.random() * 100}
              loading={loading}
              columns={columns}
              dataSource={sliderItems}
              className="ant-border-space"
              pagination={{
                position: ["none"],
              }}
            />
          </div>
        </Card>
        <Modal
          title={titleModal}
          visible={isModalEditVisible}
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
        >
          <div>
            <Form
              initialValues={valueFormData}
              form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item hidden={true} label="itemIndex" name="itemIndex">
                <Input />
              </Form.Item>
              <Form.Item
                label="Tên banner"
                name="title"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập tên!",
                  },
                ]}
              >
                <Input placeholder="Nhập tên..." />
              </Form.Item>
              <Form.Item
                label="Liên kết"
                name="link"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập liên kết!",
                  },
                ]}
              >
                <Input placeholder="Nhập liên kết..." />
              </Form.Item>
              <Form.Item
                label="Thứ tự hiển thị"
                name="order"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập thứ tự hiển thị!",
                  },
                ]}
              >
                <InputNumber min={0} />
              </Form.Item>
              <Form.Item
                label="Trạng thái"
                valuePropName="checked"
                name="active"
              >
                <Switch />
              </Form.Item>

              <Row>
                <Col>
                  <Form.Item label="Ảnh PC">
                    <UploadFileProp
                      onUploadPc={onUploadPc}
                      image={bannerPc}
                      type="first"
                    />
                  </Form.Item>
                </Col>

                <Col offset={2}>
                  <Form.Item label="Ảnh Mobile">
                    <UploadFileProp
                      onUploadMb={onUploadMb}
                      image={bannerMb}
                      type="second"
                    />
                  </Form.Item>
                  -
                </Col>
              </Row>
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default SliderCenterHome;
